import { Button,Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { color } from "../../../theme";
import React from "react";
import { useNavigate } from "react-router";
import { postApi } from "../../../Services/apiService";
import { MIS_DUMP_LOGIN } from "../../../Services/endpoints";
import { error_message } from "../../../Constant";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { SET_TOKEN_MIS, SET_USER_TYPE } from "../../../Redux/PolicyNumber/types";
import './style.css';

const LoginPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [user, setUser] = useState({});
    const { username, pwd } = user || {};
    const onFinish = async (values) => {
        try {
            const result = await postApi(MIS_DUMP_LOGIN, {
              username: username || "",
              password: pwd || "",
            });
            dispatch({type: SET_TOKEN_MIS, payload: result?.data?.accessToken})
            dispatch({type: SET_USER_TYPE, payload: result?.data?.roles[0]})
            navigate('/dashboard')
        } catch (error) {
            console.error(error)
            message.error(error_message.common_error)
        }
    };
    return (
        <div className="login_container">
            <div className="login_box">
                <label>Login</label>
                <div className="login_input_container">
                    <Form name="normal_login" className="login-form" initialValues={{ remember: true }} onFinish={onFinish} >
                        <Form.Item name="username" rules={[{ required: true, message: 'Please input your Username!' }]} >
                            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" value={username} onChange={(e) => setUser({...user ,...{username:e.target.value} })}/>
                        </Form.Item>
                        <Form.Item name="password" rules={[{ required: true, message: 'Please input your Password!' }]}   >
                            <Input prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder="Password" value={pwd || ""} onChange={(e) => setUser({...user ,...{pwd:e.target.value} })}/>
                        </Form.Item>
                        <Form.Item className={"cls_mghunsqx_ada2c6"}>
                            <Button type="primary" htmlType="submit" className="login-form-button">
                                Log in
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default LoginPage